import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

// Import Lucide icons
import {
  Plus,
  Search,
  Filter,
  Calendar,
  TrendingUp,
  TrendingDown,
  DollarSign,
  BarChart3,
  Clock,
  RefreshCw,
  ArrowUpRight,
  ArrowDownRight,
  Percent,
  Hash,
  FileText,
  Download,
  Edit3,
  Trash2,
  CheckCircle,
  X,
} from "lucide-react";

import edit from "../../../images/edit.svg";
import Delete from "../../../images/delete.svg";
import Logo from "../../../images/logo-2.png";
import { useSelector } from "react-redux";
import api from "../../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "../loader";
import { Modal } from "react-bootstrap";
import moment from "moment";
import SummaryPDF from "./sumaryPDF";
import { useAlert } from "react-alert";

export function TradeDirectory({ match }) {
  const alert = useAlert();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);
  const [monthDate, setMonthDate] = useState("");
  const [resetPage, setResetPage] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [selectedData, setSelectedData] = useState({});
  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = (item) => {
    setSelectedData(item);
    setShowEdit(true);
  };

  const getPosts = async () => {
    try {
      let payload = {
        page: page,
      };
      setLoader(true);
      const postData = await api.tradeDirectoryGet(payload);
      if (postData?.success) {
        setData(postData.trades);
        setnoOfPost(postData.count);
        setLimit(postData.limit);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const deletePost = async (id) => {
    try {
      setLoader(true);
      const isConfirmed = window.confirm(
        "Are you sure you want to delete this trade?",
      );
      if (isConfirmed) {
        const userData = await api.tradeDirectoryDelete(id);
        console.log("deleted");
        getPosts();
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getPosts();
  }, [page, resetPage]);

  const getMonthlySumary = async () => {
    try {
      if (monthDate) {
        const [year, month] = monthDate.split("-");
        let payload = {
          year,
          month,
        };
        setLoader(true);
        const res = await api.tradeDirectorySearch(payload);
        console.log(res);
        if (res?.success) {
          setData(res?.trades);
          setSummary(res?.summary);
          setLimit(res?.trades?.length || 10);
          setnoOfPost(res?.trades?.length || 0);
        } else {
          alert.error("No trades found for selected month");
        }
        setLoader(false);
      } else {
        alert.info("Please select month for search");
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleReset = () => {
    setResetPage(!resetPage);
    setPage(1);
  };

  useEffect(() => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    setMonthDate(`${year}-${month}`);
  }, []);

  return (
    <>
      <div className="trade-directory-container">
        {/* Header Section */}
        <div className="trades-header">
          <div className="content-header">
            <div className="header-left">
              <div className="header-icon-wrapper">
                <TrendingUp size={45} className="header-icon" />
              </div>
              <div className="header-title-wrapper">
                <h1 className="header-title">Trade Directory</h1>
                {/* <span className="trades-count">{noOfPost} trades</span> */}
              </div>
            </div>
            <div className="header-right">
              <div className="search-box">
                <Search size={18} className="search-icon" />
                <input
                  type="text"
                  placeholder="Search trades..."
                  className="input-search"
                />
              </div>
              <button className="add-trade-btn" onClick={handleShow}>
                <Plus size={18} />
                <span>Add Trade</span>
              </button>
            </div>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="stats-container">
          <div className="stat-card total">
            <div className="stat-icon">
              <BarChart3 size={24} />
            </div>
            <div className="stat-content">
              <span className="stat-value">{noOfPost}</span>
              <span className="label-stats">Total Trades</span>
            </div>
          </div>

          <div className="stat-card long">
            <div className="stat-icon">
              <TrendingUp size={24} />
            </div>
            <div className="stat-content">
              <span className="stat-value">
                {data.filter((t) => t?.side === "long").length}
              </span>
              <span className="label-stats">Long Positions</span>
            </div>
          </div>

          <div className="stat-card short">
            <div className="stat-icon">
              <TrendingDown size={24} />
            </div>
            <div className="stat-content">
              <span className="stat-value">
                {data.filter((t) => t?.side === "short").length}
              </span>
              <span className="label-stats">Short Positions</span>
            </div>
          </div>

          {/* <div className="stat-card closed">
            <div className="stat-icon">
              <CheckCircle size={24} />
            </div>
            <div className="stat-content">
              <span className="stat-value">
                {data.filter((t) => t?.exitPrice).length}
              </span>
              <span className="label-stats">Closed Trades</span>
            </div>
          </div>

          <div className="stat-card active">
            <div className="stat-icon">
              <Clock size={24} />
            </div>
            <div className="stat-content">
              <span className="stat-value">
                {data.filter((t) => !t?.exitPrice).length}
              </span>
              <span className="label-stats">Active Trades</span>
            </div>
          </div> */}
        </div>

        {/* Filter Section */}
        <div className="filter-section">
          <div className="filter-header">
            <h3 className="filter-title">
              <Filter size={20} />
              Monthly Analysis
            </h3>
            <button className="reset-btn" onClick={handleReset}>
              <RefreshCw size={16} />
              <span>Reset</span>
            </button>
          </div>
          <div className="filter-content">
            <div className="date-filter">
              <div className="filter-input-group">
                <Calendar size={18} className="filter-icon" />
                <input
                  type="month"
                  value={monthDate}
                  onChange={(e) => setMonthDate(e.target.value)}
                  className="month-input"
                />
              </div>
              <button className="search-button" onClick={getMonthlySumary}>
                <Search size={16} />
                <span>Search Trades</span>
              </button>
            </div>

            {summary?.avgGain && (
              <div className="summary-cards">
                <div className="summary-card profit">
                  <div className="summary-icon">
                    <ArrowUpRight size={20} />
                  </div>
                  <div className="summary-content">
                    <span className="summary-value">{summary.avgGain}%</span>
                    <span className="summary-label">Average Gain</span>
                  </div>
                </div>
                <div className="summary-card winrate">
                  <div className="summary-icon">
                    <Percent size={20} />
                  </div>
                  <div className="summary-content">
                    <span className="summary-value">{summary.winRate}%</span>
                    <span className="summary-label">Win Rate</span>
                  </div>
                </div>
                <div className="summary-card trades">
                  <div className="summary-icon">
                    <Hash size={20} />
                  </div>
                  <div className="summary-content">
                    <span className="summary-value">{summary.totalTrades}</span>
                    <span className="summary-label">Total Trades</span>
                  </div>
                </div>
                {/* <div className="summary-pdf">
                  <SummaryPDF
                    trades={data}
                    summary={summary}
                    month={monthDate}
                  />
                </div> */}
              </div>
            )}
          </div>
        </div>

        {/* Table Section */}
        <div className="table-section">
          <div className="section-header">
            <h3 className="section-title">
              <FileText size={20} />
              Trade Records
            </h3>
            <div className="section-actions">
              <span className="filter-count">
                Showing {data.length} of {noOfPost} trades
              </span>
            </div>
          </div>
          <div className="table-container">
            <Table
              data={data}
              setPage={setPage}
              page={page}
              noOfPost={noOfPost}
              limit={limit}
              deletePost={deletePost}
              handleShowEdit={handleShowEdit}
            />
          </div>
        </div>
      </div>

      {/* Modals */}
      <Modal
        show={show}
        size="lg"
        onHide={handleClose}
        centered
        className="modern-modal"
      >
        <Modal.Body>
          <div className="modal-content-wrapper">
            <div className="modal-header">
              <div className="modal-title-wrapper">
                <h2 className="modal-title">Add New Trade</h2>
                <p className="modal-subtitle">
                  Enter trade details for the directory
                </p>
              </div>
              <button className="close-modal-btn" onClick={handleClose}>
                <X size={24} />
              </button>
            </div>
            <div className="modal-body-content">
              <AddTrade getPosts={getPosts} setShow={setShow} />
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showEdit}
        size="lg"
        onHide={handleCloseEdit}
        centered
        className="modern-modal"
      >
        <Modal.Body>
          <div className="modal-content-wrapper">
            <div className="modal-header">
              <div className="modal-title-wrapper">
                <h2 className="modal-title">Close Trade</h2>
                <p className="modal-subtitle">
                  Update exit price to close this trade
                </p>
              </div>
              <button className="close-modal-btn" onClick={handleCloseEdit}>
                <X size={24} />
              </button>
            </div>
            <div className="modal-body-content">
              <EditTrade
                getPosts={getPosts}
                setShow={setShowEdit}
                tradeData={selectedData}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {loader && <Loader />}

      <style jsx="true">{`
        /* Main Container */
        .trade-directory-container {
          padding: 24px;
          min-height: 100vh;
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
        }

        /* Header Styles */
        .trades-header {
          background: white;
          border-radius: 16px;
          padding: 24px;
          margin-bottom: 24px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        }

        .content-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 16px;
        }

        .header-left {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .header-icon-wrapper {
          background: rgba(255, 255, 255, 0.2);
          padding: 14px;
          border-radius: 14px;
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .header-icon {
          color: #6366f1;
          background: #e0e7ff;
          padding: 12px;
          border-radius: 12px;
        }

        .header-title-wrapper {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        .header-title {
          font-size: 28px;
          font-weight: 700;
          color: #1e293b;
          margin: 0;
        }

        .trades-count {
          background: #6366f1;
          color: white;
          padding: 6px 16px;
          text-align: center;
          border-radius: 20px;
          font-size: 14px;
          width: 100px;
          font-weight: 600;
        }

        .header-right {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .search-box {
          position: relative;
          width: 280px;
        }

        .search-icon {
          position: absolute;
          left: 14px;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
        }

        .input-search {
          width: 100%;
          padding: 12px 20px 12px 48px;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          font-size: 14px;
          transition: all 0.3s ease;
          background: white;
        }

        .input-search::placeholder {
          color: #94a3b8;
        }

        .input-search:focus {
          outline: none;
          border-color: #6366f1;
          box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
        }

        .add-trade-btn {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 12px 20px;
          background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
        }

        .add-trade-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(99, 102, 241, 0.4);
        }

        /* Stats Cards */
        .stats-container {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 16px;
          margin-bottom: 24px;
        }

        .stat-card {
          background: white;
          border-radius: 12px;
          padding: 20px;
          display: flex;
          align-items: center;
          gap: 16px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          transition: all 0.3s ease;
          border: 1px solid #e2e8f0;
          position: relative;
          overflow: hidden;
        }

        .stat-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
        }

        .stat-card::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
        }

        .stat-card.total::before {
          background: linear-gradient(90deg, #4f46e5, #6366f1);
        }

        .stat-card.long::before {
          background: linear-gradient(90deg, #10b981, #34d399);
        }

        .stat-card.short::before {
          background: linear-gradient(90deg, #ef4444, #f87171);
        }

        .stat-card.closed::before {
          background: linear-gradient(90deg, #3b82f6, #60a5fa);
        }

        .stat-card.active::before {
          background: linear-gradient(90deg, #f59e0b, #fbbf24);
        }

        .stat-icon {
          width: 44px;
          height: 44px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          flex-shrink: 0;
        }

        .stat-card.total .stat-icon {
          background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);
        }

        .stat-card.long .stat-icon {
          background: linear-gradient(135deg, #10b981 0%, #34d399 100%);
        }

        .stat-card.short .stat-icon {
          background: linear-gradient(135deg, #ef4444 0%, #f87171 100%);
        }

        .stat-card.closed .stat-icon {
          background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
        }

        .stat-card.active .stat-icon {
          background: linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%);
        }

        .stat-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .stat-value {
          font-size: 24px;
          color: #1e293b;
          line-height: 1;
        }

        .label-stats {
          font-size: 13px;
          color: #64748b;
          font-weight: 500;
        }

        /* Filter Section */
        .filter-section {
          background: white;
          border-radius: 12px;
          padding: 20px;
          margin-bottom: 24px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          border: 1px solid #e2e8f0;
        }

        .filter-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
        }

        .filter-title {
          font-size: 16px;
          font-weight: 700;
          color: #1e293b;
          margin: 0;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .filter-title svg {
          color: #1e40af;
        }

        .reset-btn {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 6px 12px;
          background: #f1f5f9;
          color: #64748b;
          border: none;
          border-radius: 6px;
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .reset-btn:hover {
          background: #e2e8f0;
        }

        .filter-content {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .date-filter {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .filter-input-group {
          position: relative;
          flex: 1;
          max-width: 250px;
        }

        .filter-icon {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: #64748b;
        }

        .month-input {
          width: 100%;
          padding: 10px 12px 10px 40px;
          border: 2px solid #e2e8f0;
          border-radius: 10px;
          font-size: 14px;
          background: white;
          color: #1e293b;
          transition: all 0.3s ease;
        }

        .month-input:focus {
          outline: none;
          border-color: #1e40af;
          box-shadow: 0 0 0 3px rgba(30, 64, 175, 0.1);
        }

        .search-button {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 10px 16px;
          background: linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%);
          color: white;
          border: none;
          border-radius: 10px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .search-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 2px 8px rgba(30, 64, 175, 0.2);
        }

        .summary-cards {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          gap: 12px;
          margin-top: 12px;
        }

        .summary-card {
          background: #f8fafc;
          border-radius: 10px;
          padding: 16px;
          display: flex;
          align-items: center;
          gap: 12px;
          border: 1px solid #e2e8f0;
        }

        .summary-card.profit {
          border-left: 3px solid #10b981;
        }

        .summary-card.winrate {
          border-left: 3px solid #3b82f6;
        }

        .summary-card.trades {
          border-left: 3px solid #f59e0b;
        }

        .summary-icon {
          width: 36px;
          height: 36px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
        }

        .summary-card.profit .summary-icon {
          background: linear-gradient(135deg, #10b981 0%, #34d399 100%);
        }

        .summary-card.winrate .summary-icon {
          background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
        }

        .summary-card.trades .summary-icon {
          background: linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%);
        }

        .summary-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 2px;
        }

        .summary-value {
          font-size: 20px;
          font-weight: 700;
          color: #1e293b;
          line-height: 1;
        }

        .summary-label {
          font-size: 11px;
          color: #64748b;
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .summary-pdf {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        /* Table Section */
        .table-section {
          background: white;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        }

        .section-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px 20px;
          border-bottom: 1px solid #e2e8f0;
          background: #f8fafc;
        }

        .section-title {
          font-size: 16px;
          font-weight: 700;
          color: #1e293b;
          margin: 0;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .section-title svg {
          color: #1e40af;
        }

        .filter-count {
          font-size: 13px;
          color: #64748b;
          font-weight: 500;
          background: #e2e8f0;
          padding: 4px 10px;
          border-radius: 20px;
        }

        .table-container {
          padding: 0;
        }

        /* Modern Modal */
        .modern-modal .modal-content {
          border: none;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
        }

        .modal-content-wrapper {
          padding: 0;
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px 24px;
          background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%);
          color: white;
        }

        .modal-title-wrapper {
          flex: 1;
        }

        .modal-title {
          font-size: 20px;
          font-weight: 700;
          color: white;
          margin: 0;
        }

        .modal-subtitle {
          font-size: 13px;
          color: rgba(255, 255, 255, 0.9);
          margin-top: 4px;
          font-weight: 400;
        }

        .close-modal-btn {
          background: rgba(255, 255, 255, 0.15);
          border: none;
          width: 36px;
          height: 36px;
          border-radius: 8px;
          color: white;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
        }

        .close-modal-btn:hover {
          background: rgba(255, 255, 255, 0.25);
          transform: rotate(90deg);
        }

        .modal-body-content {
          padding: 24px;
          background: white;
        }

        /* Modal backdrop */
        .modal-backdrop.show {
          background: rgba(15, 23, 42, 0.6);
        }

        /* Responsive styles */
        @media (max-width: 768px) {
          .trade-directory-container {
            padding: 16px;
          }

          .trades-header {
            padding: 20px;
          }

          .content-header {
            flex-direction: column;
            align-items: stretch;
          }

          .search-box {
            width: 100%;
          }

          .add-trade-btn {
            width: 100%;
            justify-content: center;
          }

          .stats-container {
            grid-template-columns: repeat(2, 1fr);
          }

          .date-filter {
            flex-direction: column;
          }

          .filter-input-group {
            max-width: 100%;
          }

          .search-button {
            width: 100%;
            justify-content: center;
          }
        }

        @media (max-width: 480px) {
          .stats-container {
            grid-template-columns: 1fr;
          }

          .summary-cards {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </>
  );
}

const Table = ({
  data,
  page,
  setPage,
  noOfPost,
  limit,
  deletePost,
  handleShowEdit,
}) => {
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMM Do, h:mm A");
    return dateTemp;
  };

  const getSideColor = (side) => {
    switch (side?.toLowerCase()) {
      case "long":
        return "#10b981";
      case "short":
        return "#ef4444";
      case "spot":
        return "#3b82f6";
      default:
        return "#64748b";
    }
  };

  return (
    <>
      <div className="modern-table-wrapper">
        <div className="table-responsive">
          <table className="modern-table">
            <thead>
              <tr>
                <th className="tables-header">
                  <div className="header-cell">
                    <span>Pair</span>
                  </div>
                </th>
                <th className="tables-header">
                  <div className="header-cell">
                    <span>Side</span>
                  </div>
                </th>
                <th className="tables-header">
                  <div className="header-cell">
                    <span>Entry</span>
                  </div>
                </th>
                <th className="tables-header">
                  <div className="header-cell">
                    <span>TP1</span>
                  </div>
                </th>
                <th className="tables-header">
                  <div className="header-cell">
                    <span>TP2</span>
                  </div>
                </th>
                <th className="tables-header">
                  <div className="header-cell">
                    <span>TP3</span>
                  </div>
                </th>
                <th className="tables-header">
                  <div className="header-cell">
                    <span>SL</span>
                  </div>
                </th>
                <th className="tables-header">
                  <div className="header-cell">
                    <span>Exit Price</span>
                  </div>
                </th>
                <th className="tables-header">
                  <div className="header-cell">
                    <span>Created At</span>
                  </div>
                </th>
                <th className="tables-header">
                  <div className="header-cell">
                    <span>Exit At</span>
                  </div>
                </th>
                <th className="tables-header">
                  <div className="header-cell">
                    <span>Actions</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, key) => (
                <tr key={key} className="table-row">
                  <td className="table-cell">
                    <div className="cell-content">
                      <span className="pair-symbol">{item?.pair || "-"}</span>
                    </div>
                  </td>
                  <td className="table-cell">
                    <span
                      className="side-badge"
                      style={{
                        backgroundColor: getSideColor(item?.side),
                        color: "white",
                      }}
                    >
                      {item?.side || "-"}
                    </span>
                  </td>
                  <td className="table-cell">
                    <div className="price-cell">
                      <span className="price-value">
                        {item?.entryPrice || "-"}
                      </span>
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="price-cell">
                      <span className="price-value">{item?.tp1 || "-"}</span>
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="price-cell">
                      <span className="price-value">{item?.tp2 || "-"}</span>
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="price-cell">
                      <span className="price-value">{item?.tp3 || "-"}</span>
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="price-cell">
                      <span className="sl-value">{item?.stopLoss || "-"}</span>
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="price-cell">
                      <span
                        className={`exit-value ${
                          item?.exitPrice ? "closed" : "open"
                        }`}
                      >
                        {item?.exitPrice || "Open"}
                      </span>
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="date-cell">
                      <span className="date-text">
                        {formatDate(item?.createdAt)}
                      </span>
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="date-cell">
                      <span className="date-text">
                        {item?.updatedAt
                          ? formatDate(item?.updatedAt)
                          : "Active"}
                      </span>
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="action-buttons">
                      <button
                        className="action-btn edit-btn"
                        onClick={() => handleShowEdit(item)}
                        title="Edit"
                      >
                        <img src={edit} alt="edit" />
                      </button>
                      <button
                        className="action-btn delete-btn"
                        onClick={() => deletePost(item?._id)}
                        title="Delete"
                      >
                        <img src={Delete} alt="Delete" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="pagination-container">
          <div className="d-flex justify-content-center py-3">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noOfPost / limit)}
                page={page}
                onChange={handleChange}
              />
            </Stack>
          </div>
        </div>
      </div>

      <style jsx="true">{`
        .modern-table-wrapper {
          padding: 0;
        }

        .modern-table {
          width: 100%;
          border-collapse: separate;
          border-spacing: 0;
          min-width: 1000px;
        }

        .tables-header {
          background: #f1f5f9;
          padding: 14px 12px;
          text-align: left;
          font-size: 12px;
          font-weight: 600;
          color: #475569;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          border-bottom: 2px solid #e2e8f0;
        }

        .header-cell {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .table-row {
          transition: background-color 0.2s ease;
          border-bottom: 1px solid #f1f5f9;
        }

        .table-row:hover {
          background-color: #f8fafc;
        }

        .table-cell {
          padding: 14px 12px;
          vertical-align: middle;
          border-bottom: 1px solid #f1f5f9;
        }

        .pair-symbol {
          font-weight: 600;
          color: #1e293b;
          font-size: 14px;
        }

        .side-badge {
          display: inline-block;
          padding: 4px 10px;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 600;
          text-transform: capitalize;
        }

        .price-cell {
          font-family: "SF Mono", "Monaco", "Inconsolata", monospace;
        }

        .price-value,
        .sl-value {
          font-weight: 500;
          color: #1e293b;
          font-size: 13px;
        }

        .exit-value {
          font-weight: 600;
          font-size: 13px;
          font-family: "SF Mono", "Monaco", "Inconsolata", monospace;
        }

        .exit-value.closed {
          color: #3b82f6;
        }

        .exit-value.open {
          color: #f59e0b;
        }

        .date-cell {
          font-size: 12px;
          color: #64748b;
        }

        .action-buttons {
          display: flex;
          gap: 8px;
        }

        .action-btn {
          width: 32px;
          height: 32px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s ease;
          border: none;
        }

        .edit-btn {
          background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
        }

        .edit-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
        }

        .delete-btn {
          background: linear-gradient(135deg, #ef4444 0%, #f87171 100%);
        }

        .delete-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 2px 8px rgba(239, 68, 68, 0.2);
        }

        .action-btn img {
          width: 14px;
          height: 14px;
          filter: brightness(0) invert(1);
        }

        .pagination-container {
          background: #f8fafc;
          border-top: 1px solid #e2e8f0;
        }

        @media (max-width: 768px) {
          .pagination-container {
            padding: 12px;
          }
        }
      `}</style>
    </>
  );
};

// Keep the AddTrade and EditTrade components exactly as they are, just add a wrapper for styling
export function AddTrade({ getPosts, setShow }) {
  const adminStore = useSelector((state) => state.adminReducer);
  const alert = useAlert();

  const [loader, setLoader] = useState(false);
  const [inputData, setInputData] = useState({});

  const validate = () => {
    if (!inputData?.pair) {
      return "Please add pair";
    }
    if (!inputData?.side) {
      return "Please select side";
    }
    if (!inputData?.entryPrice) {
      return "Please add entry price";
    }
    return false;
  };

  const handleSubmit = async () => {
    try {
      let validator = validate();
      if (validator) {
        alert.info(validator);
        return;
      }
      setLoader(true);
      let payload = {
        postedBy: adminStore.admin.admin._id,
        pair: inputData?.pair,
        side: inputData?.side,
        entryPrice: inputData?.entryPrice,
        tp1: inputData?.tp1 || null,
        tp2: inputData?.tp2 || null,
        tp3: inputData?.tp3 || null,
        stopLoss: inputData?.stopLoss || null,
        exitPrice: inputData?.exitPrice || null,
      };
      const response = await api.tradeDirectoryCreate(payload);
      if (response?.success) {
        alert.success("Trade added successfully.");
        setInputData({
          email: "",
          description: "",
        });
        setLoader(false);

        getPosts();
        setShow(false);
      } else {
        setLoader(false);
        alert.error("Something went wrong");
      }
    } catch (error) {
      setLoader(false);
      console.log(error?.message);
      console.log(error);
      alert.error(error?.message || "Something went wrong");
    }
  };

  return (
    <>
      <style jsx="true">{`
        .modal-form-container {
          padding: 0;
        }

        .modal-form-title {
          font-size: 18px;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 16px;
        }

        .modal-form-group {
          margin-bottom: 16px;
        }

        .modal-form-label {
          display: block;
          font-size: 14px;
          font-weight: 500;
          color: #475569;
          margin-bottom: 6px;
        }

        .modal-form-control {
          width: 100%;
          padding: 10px 12px;
          border: 2px solid #e2e8f0;
          border-radius: 8px;
          font-size: 14px;
          transition: all 0.3s ease;
          background: white;
        }

        .modal-form-control:focus {
          outline: none;
          border-color: #1e40af;
          box-shadow: 0 0 0 3px rgba(30, 64, 175, 0.1);
        }

        .modal-form-control:disabled {
          background: #f8fafc;
          cursor: not-allowed;
        }

        .modal-form-actions {
          display: flex;
          justify-content: flex-end;
          gap: 12px;
          margin-top: 24px;
          padding-top: 16px;
          border-top: 1px solid #e2e8f0;
        }

        .modal-form-btn {
          padding: 10px 20px;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          border: none;
        }

        .modal-form-btn.primary {
          background: linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%);
          color: white;
        }

        .modal-form-btn.primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 2px 8px rgba(30, 64, 175, 0.2);
        }

        .modal-form-btn.secondary {
          background: #f1f5f9;
          color: #64748b;
        }

        .modal-form-btn.secondary:hover {
          background: #e2e8f0;
        }

        .seekoLoader {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(255, 255, 255, 0.9);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }

        .loader {
          text-align: center;
        }

        .loader img {
          width: 60px;
          height: 60px;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>

      <div className="modal-form-container">
        <div className="modal-form-group">
          <input
            type="text"
            name="pair"
            value={inputData?.pair}
            className="modal-form-control"
            placeholder="Enter Pair"
            onChange={(e) =>
              setInputData({ ...inputData, pair: e.target.value })
            }
          />
        </div>
        <div className="modal-form-group">
          <select
            className="modal-form-control"
            onChange={(e) =>
              setInputData({ ...inputData, side: e.target.value })
            }
          >
            <option value="">select Side</option>
            <option value="long">Long</option>
            <option value="short">Short</option>
            <option value="spot">Spot</option>
          </select>
        </div>
        <div className="modal-form-group">
          <input
            type="number"
            name="entryPrice"
            value={inputData?.entryPrice}
            className="modal-form-control"
            placeholder="Entry Price"
            onChange={(e) =>
              setInputData({ ...inputData, entryPrice: e.target.value })
            }
          />
        </div>
        <div className="modal-form-group">
          <input
            type="number"
            name="tp1"
            value={inputData?.tp1}
            className="modal-form-control"
            placeholder="Take Profit 1"
            onChange={(e) =>
              setInputData({ ...inputData, tp1: e.target.value })
            }
          />
        </div>
        <div className="modal-form-group">
          <input
            type="number"
            name="tp2"
            value={inputData?.tp2}
            className="modal-form-control"
            placeholder="Take Profit 2"
            onChange={(e) =>
              setInputData({ ...inputData, tp2: e.target.value })
            }
          />
        </div>
        <div className="modal-form-group">
          <input
            type="number"
            name="tp3"
            value={inputData?.tp3}
            className="modal-form-control"
            placeholder="Take Profit 3"
            onChange={(e) =>
              setInputData({ ...inputData, tp3: e.target.value })
            }
          />
        </div>
        <div className="modal-form-group">
          <input
            type="number"
            name="stopLoss"
            value={inputData?.stopLoss}
            className="modal-form-control"
            placeholder="Stop Loss"
            onChange={(e) =>
              setInputData({ ...inputData, stopLoss: e.target.value })
            }
          />
        </div>
        <div className="modal-form-group">
          <input
            type="number"
            name="exitPrice"
            value={inputData?.exitPrice}
            className="modal-form-control"
            placeholder="Exit Price"
            onChange={(e) =>
              setInputData({ ...inputData, exitPrice: e.target.value })
            }
          />
        </div>

        <div className="modal-form-actions">
          <button
            className="modal-form-btn secondary"
            onClick={() => setShow(false)}
          >
            Cancel
          </button>
          <button className="modal-form-btn primary" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>

      {loader && (
        <div className="seekoLoader">
          <div className="loader">
            <img src={Logo} alt="loader" />
          </div>
        </div>
      )}
    </>
  );
}

export function EditTrade({ getPosts, setShow, tradeData }) {
  const adminStore = useSelector((state) => state.adminReducer);
  const alert = useAlert();

  const [loader, setLoader] = useState(false);
  const [inputData, setInputData] = useState({});

  const validate = () => {
    if (!inputData?.exitPrice) {
      return "Please add exit price";
    }

    return false;
  };

  const handleSubmit = async () => {
    try {
      let validator = validate();
      if (validator) {
        alert.info(validator);
        return;
      }
      setLoader(true);
      let payload = {
        id: inputData._id,
        exitPrice: inputData?.exitPrice,
      };
      const response = await api.tradeDirectoryExit(payload);
      if (response?.success) {
        alert.success("Trade closed.");
        setInputData({
          email: "",
          description: "",
        });
        setLoader(false);

        getPosts();
        setShow(false);
      } else {
        setLoader(false);
        alert.error("Something went wrong");
      }
    } catch (error) {
      setLoader(false);
      console.log(error?.message);
      console.log(error);
      alert.error(error?.message || "Something went wrong");
    }
  };

  useEffect(() => {
    setInputData({
      _id: tradeData?._id,
      pair: tradeData?.pair,
      side: tradeData?.side,
      entryPrice: tradeData?.entryPrice,
      tp1: tradeData?.tp1 || null,
      tp2: tradeData?.tp2 || null,
      tp3: tradeData?.tp3 || null,
      stopLoss: tradeData?.stopLoss || null,
      exitPrice: tradeData?.exitPrice || null,
    });
  }, []);

  return (
    <>
      <style jsx="true">{`
        .modal-form-container {
          padding: 0;
        }

        .modal-form-title {
          font-size: 18px;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 16px;
        }

        .modal-form-group {
          margin-bottom: 16px;
        }

        .modal-form-label {
          display: block;
          font-size: 14px;
          font-weight: 500;
          color: #475569;
          margin-bottom: 6px;
        }

        .modal-form-control {
          width: 100%;
          padding: 10px 12px;
          border: 2px solid #e2e8f0;
          border-radius: 8px;
          font-size: 14px;
          transition: all 0.3s ease;
          background: white;
        }

        .modal-form-control:focus {
          outline: none;
          border-color: #1e40af;
          box-shadow: 0 0 0 3px rgba(30, 64, 175, 0.1);
        }

        .modal-form-control:disabled {
          background: #f8fafc;
          cursor: not-allowed;
        }

        .modal-form-actions {
          display: flex;
          justify-content: flex-end;
          gap: 12px;
          margin-top: 24px;
          padding-top: 16px;
          border-top: 1px solid #e2e8f0;
        }

        .modal-form-btn {
          padding: 10px 20px;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          border: none;
        }

        .modal-form-btn.primary {
          background: linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%);
          color: white;
        }

        .modal-form-btn.primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 2px 8px rgba(30, 64, 175, 0.2);
        }

        .modal-form-btn.secondary {
          background: #f1f5f9;
          color: #64748b;
        }

        .modal-form-btn.secondary:hover {
          background: #e2e8f0;
        }
      `}</style>

      <div className="modal-form-container">
        <div className="modal-form-group">
          <input
            type="text"
            name="pair"
            value={inputData?.pair}
            className="modal-form-control"
            placeholder="Enter Pair"
            onChange={(e) =>
              setInputData({ ...inputData, pair: e.target.value })
            }
            disabled
          />
        </div>
        <div className="modal-form-group">
          <select
            className="modal-form-control"
            value={inputData?.side}
            onChange={(e) =>
              setInputData({ ...inputData, side: e.target.value })
            }
            disabled
          >
            <option value="">select Side</option>
            <option value="long">Long</option>
            <option value="short">Short</option>
            <option value="spot">Spot</option>
          </select>
        </div>
        <div className="modal-form-group">
          <input
            type="number"
            name="exitPrice"
            value={inputData?.exitPrice}
            className="modal-form-control"
            placeholder="Exit Price"
            onChange={(e) =>
              setInputData({ ...inputData, exitPrice: e.target.value })
            }
          />
        </div>

        <div className="modal-form-actions">
          <button
            className="modal-form-btn secondary"
            onClick={() => setShow(false)}
          >
            Cancel
          </button>
          <button className="modal-form-btn primary" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>

      {loader && (
        <div className="seekoLoader">
          <div className="loader">
            <img src={Logo} alt="loader" />
          </div>
        </div>
      )}
    </>
  );
}
